import { AppProviders } from '@/app/providers';
import { AppRouter } from '@/app/router';

// Portal composition root: shared providers wrap the route tree. Auth, profiles, and home live in feature
// slices under src/features/*; app-level wiring stays here.
export function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
